import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from '../../../../../app.main.component';
import { ConfigurationService } from '../../../../configurationService';
import { Answer } from '../../../../crm/constants/constants';
import { JobFunction } from '../../models/job-function.model';
import { UpdateJobType } from '../../models/job-type.model';
import { TerritoryConfigUpdatePayload } from '../../models/territory-config-update.model';
import { JobFunctionInConfig, TerritoryConfig } from '../../models/territory-config.model';
import { TerritoryService } from '../../services/territory.service';
import { ENABLE_TERRITORY_MSG } from '../../constant/territorry-msg.constant';

@Component({
  selector: 'app-fsm-territory-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss']
})
export class FsmTerritoryActionComponent implements OnInit {

  /* Subject to unsubscribe */
  private ngUnsubscribe = new Subject<void>();
  
  territoryConfig: TerritoryConfig[] = [];
  showJobfunctionTable: boolean = false;
  jobFunctionListInConfig: JobFunctionInConfig[] = [];
  checkLeadAndAccountOwner: boolean;
  initialCheckUncheckState: boolean;
  showSaveBtn: boolean = false;
  territoryUpdatePayload: Partial<TerritoryConfigUpdatePayload> = {};
  territoryEnabledDisabledModel: boolean;
  jobFunctionList: JobFunction[] = [];
  displayJobFunctionModal: boolean = false;
  selectedJobTypes: JobFunction[] = [];
  enableTerritoryWarningMsg: string;

  @ViewChild('jobFunctionTable') jobFunctionTable: Table | undefined;

  stateOptions: any[];
  stateValue: string = "off";

  constructor(
    private confirmationService: ConfirmationService,
    private service: ConfigurationService,
    public app: AppMainComponent,
    private appMainService: AppMainService,
    public territoryService: TerritoryService,
    private messageService: MessageService,
    private primeNgTableComponent: Table
  ) { 
    this.enableTerritoryWarningMsg = ENABLE_TERRITORY_MSG;
  }

  ngOnInit(): void {
    this.getTerritoryConfig();
    this.stateOptions = [{label: 'Off', value: 'off'}, {label: 'On', value: 'on'}];
  }

  getTerritoryConfig(): void {
    this.appMainService.isShowSpinner('getTerritoryConfig');
    this.territoryService.getTerritoryConfig()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    const data = response;
                    if (data?.isTerritoryManagementEnabled){
                      this.showJobfunctionTable = true;
                      this.jobFunctionListInConfig = data?.getJobTypeConfig;
                    }
                    else {
                      this.showJobfunctionTable = false;
                    }
                    
                    this.checkLeadAndAccountOwner = data?.territoryOwnerSameAsAccount;
                    this.initialCheckUncheckState = data?.territoryOwnerSameAsAccount;
                    this.territoryEnabledDisabledModel = data?.isTerritoryManagementEnabled;

                    this.territoryConfig = [];
                    this.territoryConfig.push(data);
                    this.appMainService.isHideSpinner('getTerritoryConfig');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('getTerritoryConfig');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'Territory config is not loaded..' });
                }),
                complete: (() => {
                })
            });
    
  }

  enableDisableTerritory(data: any, actionType: string): void {
    this.confirmationService.confirm({
        message: "Are you sure that you want to proceed?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "Cancel",
        accept: () => {
          if (actionType == 'disabled'){
            this.territoryEnabledDisabledModel = false;
            this.checkLeadAndAccountOwner = false;
          }
          else {
            this.territoryEnabledDisabledModel = true;
          }
          data.isTerritoryManagementEnabled = !data.isTerritoryManagementEnabled;
          this.updateTerritoryConfig();
        },
    });
  }

  
  updateTerritoryConfig(): void {
    const data: TerritoryConfigUpdatePayload = {
      id: this.territoryConfig[0].id,
      isTerritoryManagementEnabled: this.territoryEnabledDisabledModel,
    }
    this.appMainService.isShowSpinner('updateTerritoryConfig');
    this.territoryService.updateTerritoryConfig(data)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                  this.showSaveBtn = false;
                  this.getTerritoryConfig();
                  this.appMainService.isHideSpinner('updateTerritoryConfig');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('updateTerritoryConfig');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'Territory was not updated, please try again later..' 
                    });
                }),
                complete: (() => {
                })
            });
    
  }

  checkUncheckLeadAndAccountOwner(event): void {
    if(event.checked !== this.initialCheckUncheckState){
      this.showSaveBtn = true;
    } else {
      this.showSaveBtn = false;
    }
  }

  saveLeadAndAccountOwnerChange(): void {
    this.confirmationService.confirm({
      message: "Are you sure that you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      accept: () => {
          this.updateTerritoryConfig();
      },
    });
  }

  getJobFunctionLists(): void {
    this.appMainService.isShowSpinner('getJobFunctionList');
    this.territoryService.getJobFunctionLists()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                  this.jobFunctionList = response;
                  if (this.jobFunctionListInConfig != null && this.jobFunctionListInConfig?.length > 0){
                    this.findSelectedJobFunction();
                  }
                  this.displayJobFunctionModal = true;
                  this.appMainService.isHideSpinner('getJobFunctionList');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('getJobFunctionList');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'Job function lists are not loaded, please try again later..' 
                    });
                }),
                complete: (() => {
                })
            });
  }

  findSelectedJobFunction(): void {
    this.selectedJobTypes = [];
    this.selectedJobTypes = this.jobFunctionListInConfig.map((item) => {
      const matchObj = this.jobFunctionList.find(obj => obj?.id === item?.jobTypeId);
      return {
        id: item?.jobTypeId,
        name: item?.jobTypeName,
        description: matchObj?.description
      }
    })
  }

  cancelJobFunctionModal() {
    this.displayJobFunctionModal = false;
    this.selectedJobTypes.splice(0, this.selectedJobTypes.length);
    this.jobFunctionTable.selectionKeys = {};
  }

  saveJobFunction(): void {
      let jobFunctions: UpdateJobType[] = [];
      jobFunctions = this.selectedJobTypes.map(obj => ({
        territoryConfigId: this.territoryConfig[0]?.id,
        jobTypeId: obj?.id
      }));
      if (jobFunctions.length === 0){
        const data: UpdateJobType = {
          territoryConfigId: this.territoryConfig[0]?.id,
          jobTypeId: null
        }
        jobFunctions.push(data);
      }
      this.appMainService.isShowSpinner('updateJobFunctionList');
      this.territoryService.updateJobFunctions(jobFunctions)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                  this.selectedJobTypes.splice(0, this.selectedJobTypes.length);
                  this.displayJobFunctionModal = false;
                  this.jobFunctionTable.selectionKeys = {};
                  this.getTerritoryConfig();
                  this.appMainService.isHideSpinner('updateJobFunctionList');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('updateJobFunctionList');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'Job function lists are not updated, please try again later..' 
                    });
                }),
                complete: (() => {
                })
            });
    
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
